import * as React from "react";
import { DayPicker } from "react-day-picker";

import { cn } from "@/lib/utils";
import { buttonVariants } from "@/shadcn/components/ui/button";
import "react-day-picker/dist/style.css"; // important!

export type CalendarProps = React.ComponentProps<typeof DayPicker>;


function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("p-3", className)}
      classNames={{
        head_row: "flex w-full justify-between", // Add spacing
        head_cell:  "text-muted-foreground rounded-md w-9 h-9 font-normal text-[0.8rem] flex items-center justify-center",
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-sm font-medium",
        nav: "space-x-1 flex items-center",
        nav_button: cn(
          buttonVariants({ variant: "outline" }),
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"
        ),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",      
        row: "flex w-full mt-2",        
        day_hidden: "invisible",

        cell: "relative p-0 text-center text-sm h-9 w-9",
        day: "h-9 w-9 p-0 font-normal aria-selected:opacity-100",
        day_selected:
          "bg-primary text-white hover:bg-primary/90 focus:bg-primary focus:text-white rounded-md",
        day_range_start:
          "bg-accent text-accent-foreground rounded-l-md",
        day_range_end:
          "bg-accent text-accent-foreground rounded-r-md",
        day_range_middle:
          "bg-accent/50 text-accent-foreground",
        day_outside:
          "text-muted-foreground opacity-50",
        day_disabled:
        "text-muted-foreground opacity-50",
        day_today: "border border-primary font-semibold",

        ...classNames,
      }}
      {...props}
    />
  );
}
Calendar.displayName = "Calendar";

export { Calendar };
